import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface GavetaMovimentacaoProps {
  titulo: string;
  onFechar: () => void;
  children: React.ReactNode;
}

/** Gaveta ao lado da Movimentação (equipamento, Logística ou Termo) — largura fixa no
 * MovimentacaoCard (grid de 440px), desce pra baixo da lista em tela estreita. */
export default function GavetaMovimentacao({ titulo, onFechar, children }: GavetaMovimentacaoProps) {
  return (
    <aside aria-label={titulo} className="min-w-0 rounded-lg border border-gray-200 bg-white shadow-md">
      <div className="flex items-center justify-between gap-2 border-b border-gray-100 px-4 py-2">
        <p className="font-montserrat font-semibold text-gray-900">{titulo}</p>
        <button
          type="button"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100"
          onClick={onFechar}
        >
          <span className="sr-only">Fechar</span>
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      <div className="p-4">{children}</div>
    </aside>
  );
}
